import React from "react";
import styles from "./app-toggle.module.scss";

interface IProps {
  isOn: boolean;
  onSwitch?: (isOn: boolean) => void;
  size?: "sm" | "md" | "lg";
  disabled?: boolean;
  variant?: "default" | "primary";
}

const AppToggle = (props: IProps) => {
  const {
    onSwitch,
    isOn,
    size = "md",
    disabled = false,
    variant = "default",
  } = props;

  return (
    <button
      type="button"
      role="switch"
      aria-checked={isOn}
      disabled={disabled}
      className={`${styles.appToggle} ${styles[size]} ${styles[variant]} ${
        isOn ? styles.isOn : styles.isOff
      } ${disabled ? styles.disabled : ""}`}
      onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation();
        if (!disabled && onSwitch) {
          onSwitch(!isOn);
        }
      }}
    >
      <span
        className={`${styles.button} ${isOn ? styles.end : styles.start}`}
      />
    </button>
  );
};

export default AppToggle;
